import { default as typeProcess } from './type-process/routes'
import { default as typeSubscription } from './type-subscription/routes'
import { default as documentType } from './document-type/routes'
import { default as groupSubscriber } from './group-subscriber/routes'
import { default as userSubscriber } from './user-subscriber/routes'

export default [
    ...typeProcess,
    ...typeSubscription,
    ...documentType,
    ...groupSubscriber,
    ...userSubscriber
]